// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopExtendedTasks(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_extended_tasks${startDate ? `?start_date=${startDate}` : ''}`);
}
